<template>
  <div :key="model.Codigo">
    <b-card class="mb-3 mt-3">
      <core-Form ref="form">
        <b-form-row>
          <b-form-group label="Banco" class="col-6">
            <input-select
              v-model="model.banco"
              :input="changeBanco"
              :options="bancos"
              required
            />
          </b-form-group>

          <b-form-group label="Agência" class="col-3">
            <input-select
              v-model="model.agencia"
              :input="changeAgencia"
              :options="agencias"
              required
            />
          </b-form-group>

          <b-form-group label="Conta" class="col-3">
            <input-select
              v-model="model.conta"
              :input="changeConta"
              :search="pesquisaConta"
              :options="contas"
              :disabled="!model.agencia"
              required
            />
          </b-form-group>
        </b-form-row>

        <b-form-row v-if="!hideInfo">
          <b-form-group label="Cliente" class="col-6">
            <b-input v-model="model.nome" :disabled="true" />
          </b-form-group>

          <b-form-group label="Documento Federal" class="col-3">
            <input-documento
              v-model="model.documentoFederal"
              :disabled="true"
            />
          </b-form-group>

          <b-form-group label="Tipo Pessoa" class="col-3">
            <b-form-select
              v-model="model.tipoPessoa"
              :options="$api.Arrays.TiposPessoa"
              :disabled="true"
            />
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <slot name="extraBtns"></slot>
        </b-form-row>
      </core-Form>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bancos: [],
      agencias: [],
      contas: [],
      firstLoadSelected: true
    }
  },
  props: {
    value: Object,
    codigoAgenciaSelected: String,
    codigoContaSelected: String,
    numeroContaSelected: String,
    hideInfo: { type: Boolean, default: false },
    contaNullable: { type: Boolean, default: false }
  },
  computed: {
    model: {
      get() {
        var obj = this.value
        return obj
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    codigoContaSelected: function (val) {
      if (val && this.codigoAgenciaSelected) {
        this.firstLoadSelected = true
        this.model.agencia = this.agencias.find(
          a => a.value === this.codigoAgenciaSelected
        )
        this.changeAgencia(this.model.agencia)
      }
    }
  },
  created() {
    this.pesquisaConta = _.debounce(this.loadComboContas, 300)
  },
  methods: {
    validate() {
      return this.$api.UI.FormValidate(this.$refs.form)
    },
    loadComboBancos() {
      let th = this
      th.$api.Bancos.GetBancosInternos().then(function (data) {
        if (Array.isArray(data)) {
          data.forEach(function (item) {
            let banco = {
              value: item.codigo,
              text: item.numero + ' - ' + item.descricao
            }
            th.bancos.push(banco)
            if (item.numero === process.env.VUE_APP_BANCO) {
              th.model.banco = banco
            }
          })

          th.changeBanco(th.model.banco)
        }
      })
    },
    loadComboContas(conta) {
      let th = this
      this.contas = []

      if (!!this.model.agencia && !!this.model.agencia.value) {
        if (this.firstLoadSelected && this.numeroContaSelected) {
          conta = this.numeroContaSelected
        }
        let dto = {
          parameters: [
            { name: 'codigoAgencia', value: this.model.agencia.value },
            { name: 'numeroConta', value: conta }
          ]
        }

        th.$api.Contas.ComboContas(dto).then(function (data) {
          if (data) {
            if (!data.length || data.length === 0) {
              th.$api.UI.ShowError(
                'Erro',
                'Não foram encontradas contas com os parâmetros informados.'
              )
            } else {
              data.forEach(function (item) {
                th.contas.push({
                  value: item.codigo,
                  text: item.contaPgto,
                  contaPgto: th.$api.UI.Format.ContaPgto(item.contaPgto),
                  descricao: item.descricao,
                  tipoConta: item.tipoConta,
                  numero: item.numero,
                  digito: item.digito
                })
              })
              if (th.codigoContaSelected && th.firstLoadSelected) {
                th.model.conta = th.contas.find(
                  e => e.value === th.codigoContaSelected
                )
                th.changeConta(th.model.conta)
                th.firstLoadSelected = false
              }
            }
          }
        })
      }
    },
    changeBanco() {
      let th = this
      let val = th.model.banco

      if (!val) return

      this.agencias = []
      this.model.agencia = null
      this.changeAgencia(null)

      if (val) {
        this.model.codigoBanco = val.value
        let dto = {
          parameters: [{ name: 'codigoBanco', value: val.value }]
        }
        th.$api.Agencias.GetAll(dto)
          .then(function (data) {
            if (data) {
              if (!data.length || data.length === 0) {
                th.$api.UI.ShowError(
                  'Erro',
                  'Não existem agências cadastradas para este banco.'
                )
              } else {
                data.forEach(function (item) {
                  th.agencias.push({
                    value: item.codigo,
                    text: item.numero + '-' + item.digito + ' ' + item.nome,
                    numero: item.numero,
                    digito: item.digito
                  })
                })
              }
            }
          })
          .then(function () {
            th.$api.Agencias.GetCodigoAgenciaPadrao().then(function (data) {
              if (data && data.length > 0) {
                var agenciaPadrao = th.agencias.find(ag => {
                  return ag.value === data
                })
                if (agenciaPadrao !== undefined) {
                  th.model.agencia = agenciaPadrao
                  th.changeAgencia(agenciaPadrao)
                }
              }
            })
          })
      }
    },
    changeAgencia(val) {
      let th = this
      th.model.conta = null
      th.contas = []

      if (val) {
        th.model.codigoAgencia = val.value
        th.model.agenciaPagador = val.text
      }
      this.$nextTick(function () {
        this.loadComboContas()
      })
    },
    changeConta(val) {
      let th = this
      this.model.nome = ''
      this.model.documentoFederal = ''
      this.model.tipoPessoa = null

      let dto

      if (this.contaNullable && !val) {
        this.model.contaPagador = null
        this.model.codigoConta = null

        dto = {
          parameters: [{ name: 'codigoConta', value: null }]
        }

        th.model = Object.assign({}, th.model)
      } else {
        this.model.contaPagador = val.text
        this.model.codigoConta = val.value

        dto = {
          parameters: [{ name: 'codigoConta', value: val.value }]
        }
      }

      th.$api.Parceiros.GetParceiroPorConta(this.model.codigoConta).then(
        function (data) {
          th.model.parceiroNome = data.parceiroNome
        }
      )

      th.$api.ContaCorrentistas.GetAll(dto).then(function (data) {
        if (Array.isArray(data)) {
          data.forEach(function (item) {
            if (item.titularidade === 1) {
              th.model.nome = item.nome
              th.model.details = item
              th.model.documentoFederal = th.$api.UI.Format.DocumentoFederal(
                item.documentoFederal
              )
              th.model.tipoPessoa = item.tipoPessoa
              th.model = Object.assign({}, th.model) // atualiza objeto em tela
            }
          })
        }
      })
    }
  },
  beforeMount: function () {
    this.loadComboBancos()
  }
}
</script>
